export default __webpack_public_path__ + "static/media/desk_krush.9f430c4b.webp";